import React, {
  useContext,
  // useEffect,
  useState,
  //  useEffect
} from "react";

// import data_meta1 from "../geograph/metadatas/meta_data_20260205";
// import meta_mieruka from "../mieruka/meta_mieruka_20260121";
import { data_meta, data_meta_map } from "../importmetadata";
let metadata = data_meta


// import { Dev_hanrei } from "./dev_hanrei"
// import Hanrei_canvas from "./hanrei_canvas"
import { Hanrei_canvas_list } from "./hanrei_canvas_list";
import Csv2kml from "../makekml/csv2kml";
import { MultiSetting } from "../kashikabuttons";
import { Area1Set, Area2Set } from "../App";
// import { Map1set } from "../buttons"
// import { Link, useParams } from "react-router-dom";
import { Modalcity0set } from "../geograph/modals/citysetmodal";
import { ModeSet } from "../App";

// まだフォームが動かない、、、

export const MessageForm = (props) => {
  // ステート用のフック（テキストの初期値は空っぽ）
  // const [message, setMessage] = useState('');

  // const handleChange = (e) => {
  //   setMessage(e.target.value);
  // };
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);

  const handleChange = (event) => {
    setArea1Set(event.target.value);
  };

  // console.log(area1set);

  return (
    <div className="mx-5">
      <input
        className="p-2 border border-gray-300 rounded text-black"
        value={area1set}
        onChange={handleChange}
        // rows="10"
      />
      <p className="mt-4">You typed: {area1set}</p>
    </div>
    //     <div>
    //   <label className="mx-5 text-2xl">
    //     {props.city}{area1set}{area2set}
    //     <input
    //       type="text"
    //       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
    //     />
    //   </label>
    //   <input
    //     type="submit"
    //     // value="送信"
    //     className=""
    //     onClick={() => {
    //       localStorage.setItem("area1set", "福岡県飯塚市");
    //     }}
    //   />
    // </div>
  );
};
// まだフォームが動かない、、、

export const Devtools = () => {
  // マッチソーターでリストの絞り込み機能を追加！
  // https://www.npmjs.com/package/match-sorter

  const { area1set, setArea1Set } = useContext(Area1Set);
  const [showcityset, setShowcityset] = useState(false);
  const { modeset, setModeSet } = useContext(ModeSet);

  return (
    <>
      <div className="absolute z-30 font-mono text-black w-full h-screen bg-white">
        <div className="min-h-[8vh] mt-5 text-2xl text-left w-full text-black text-extrabold bg-gradient-to-r from-cyan-200 to-blue-400 hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium px-5 py-2.5">
          教職員向けページ
          <br />
          <span className="text-sm">
            （本URLは個人ごとに発行しておりますので、共有はお控えください。追加発行については、帝国書院営業職員までご遠慮なくお知らせください。）
          </span>
        </div>
        {/*  <div onClick={() =>{ setShowcityset(212);setModeSet(1)}} className="mx-5">
            <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group bg-gradient-to-br from-cyan-500/50 to-blue-500/50 group-hover:from-cyan-500/50 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 w-full mb-1 z-0">
              <span className="relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md group-hover:bg-opacity-0 pointer-events-auto w-full">
              {area1set}
              </span>
            </button>
          </div> */}
        <div className="flex flex-col text-left m-4 w-11/12 mx-auto">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="inline-block min-w-full align-middle dark:bg-gray-800">
              <div className="my-10 text-white text-left ml-20 text-3xl">
                {localStorage.getItem("area1set")}
              </div>
              <div className="my-5 text-white text-center">
                {/* <MessageForm city={area1set} /> */}
              </div>
              <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      {/* <th scope="col" className="p-4">
                        <div className="flex items-center">
                          <input id="checkbox-search-all" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                          <label htmlFor="checkbox-search-all" className="sr-only">checkbox</label>
                        </div>
                      </th> */}
                      <th
                        scope="col"
                        className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                      >
                        NO
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                      >
                        テーマ
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                      >
                        高さ
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                      >
                        色
                      </th>
                      <th
                        scope="col"
                        className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"
                      >
                        <span className="">KML</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {metadata.map((r) => {
                      return (
                        <>
                          <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                            {/* <td className="p-4 w-4">
                          <div className="flex items-center">
                              <input id="checkbox-search-1" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                              <label htmlFor="checkbox-search-1" className="sr-only">checkbox</label>
                          </div>
                      </td> */}
                            <td className="py-3 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              <MultiSetting
                                modeset={1}
                                fullviewerset={0}
                                rendouset={true}
                                syukurenset={false}
                                static2map1set={r}
                                static2map2set={r}
                                rotate1set={false}
                                rotate2set={false}
                                area1set={"福岡県糸島市"}
                                area2set={"福岡県糸島市"}
                                year1set={r.year5}
                                year2set={r.year5}
                                no={r.no}
                              >
                                {r.no}
                              </MultiSetting>
                            </td>
                            <td className="py-3 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              <MultiSetting
                                modeset={1}
                                fullviewerset={0}
                                rendouset={true}
                                syukurenset={false}
                                static2map1set={r}
                                static2map2set={r}
                                rotate1set={false}
                                rotate2set={false}
                                area1set={"福岡県糸島市"}
                                area2set={"福岡県糸島市"}
                                year1set={r.year5}
                                year2set={r.year5}
                                no={r.no}
                              >
                                {r.title}
                              </MultiSetting>
                            </td>
                            <td className="py-3 px-6 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">
                              {r.hanrei_height_name}
                            </td>
                            <td className="py-3 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              {r.hanrei_color_name}
                            </td>
                            <td className="py-3 px-6 text-sm font-medium text-right whitespace-nowrap">
                              <a
                                href="#"
                                className="text-blue-600 dark:text-blue-500 hover:underline"
                              >
                                <Csv2kml meta={r} area={"福岡県糸島市"}>
                                  <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                    <svg
                                      className="fill-current w-4 h-4 mr-2"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                    >
                                      <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
                                    </svg>
                                    <span>KML</span>
                                  </button>
                                </Csv2kml>
                              </a>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <Modalcity0set show={showcityset} setShow={setShowcityset} />
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <Hanrei_canvas_list metadata={metadata}>
            凡例一括ダウンロード
          </Hanrei_canvas_list>
          <br />
        </div>

        {/*
            {metadata.map((r)=>{
              return <div>
                {r.title}
                <Csv2kml
                  meta = {r}
                  area = {"福岡県糸島市"}
                >
                <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
              <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
            <span>
              Download
              </span>
          </button>

                    </Csv2kml>
                    </div>
            })} */}
        {/* <div className="flex" id="hanreilist">
                    <div className="">
                      {metadata.map((r)=>
                      <>
                      <Hanrei_canvas metadata={r} year={r.year5}/>
                      <Dev_hanrei metadata={r} />
                      </>
                      )}
                    </div>
                  </div> */}
      </div>
    </>
  );
};
